
import { Route, BrowserRouter, Routes } from "react-router-dom";
import { MenuBar } from "./MenuBar";
import LoginPage from "./LoginPage";
import RusaDashboard from "./Dashboard";
import RusaTabs from "./RusaComponents/RusaTabs";
import ChangePassword from "./ChangePassword";
import ForgotPassword from "./ForgotPassword";
import ExcelFileUpload from "./assets/ApRusa/ExcelFileUpload";
import SchemewiseReport from "./CommonUtils/SchemewiseReport";
import MainDashboard from "./MainDashboard";
import ServiceMapping from "./RusaComponents/ServiceMapping";
import UniversityFacultyData from "./UniversityFacultyData";
import SubjectWiseFacultyData from "./SubjectWiseFacultyData";

const RoutesComponent = () => (
    <BrowserRouter>
        <Routes>
            <Route path="/" element={<LoginPage />} />

            <Route path="/UniversityFacultyData" element={<UniversityFacultyData />} />

            <Route path="/SubjectWiseFacultyData" element={<SubjectWiseFacultyData />} />


            <Route path="/RusaDashboard" element={<RusaDashboard />} />
            <Route path="/ForgotPassword" element={<ForgotPassword />} />
            <Route path="/StatusSubmissionForm" element={<MenuBar><RusaTabs />   </MenuBar>} />
            <Route path="/ChangePassword" element={<MenuBar>  <ChangePassword /></MenuBar>} />
            <Route path="/excelFileUpload" element={<MenuBar> <ExcelFileUpload /></MenuBar>} />
            <Route path="/home" element={<MenuBar><MainDashboard /></MenuBar>} />
            <Route path="/ServiceMapping" element={<MenuBar>  <ServiceMapping /></MenuBar>} />




            {/* <Route path="/ForgotPassword" element={<MenuBar>  <ForgotPassword /></MenuBar>} /> */}
            <Route path="/SchemewiseReport" element={<MenuBar>  <SchemewiseReport /></MenuBar>} />
        </Routes>
    </BrowserRouter>

);

export default RoutesComponent;
